module.exports = __webpack_public_path__ + "img/duck_circle.96f41ccc.png";